export enum ErrorType {
    INSUFFICIENT_BALANCE = 'INSUFFICIENT_BALANCE',
    MODEL_ACCESS_RESTRICTED = 'MODEL_ACCESS_RESTRICTED',
    GUEST_RATE_LIMITED = 'GUEST_RATE_LIMITED',
    TOO_MANY_FILES = 'TOO_MANY_FILES',
    USER_UNAUTHORIZED = 'USER_UNAUTHORIZED',
    AUTHORIZATION_FAILED = 'AUTHORIZATION_FAILED',
    GENERATION_FAILED = 'GENERATION_FAILED',
    IMAGE_GENERATION_FAILED = 'IMAGE_GENERATION_FAILED',
    IMAGE_UPLOAD_FAILED = 'IMAGE_UPLOAD_FAILED',
    UNKNOWN_ERROR = 'UNKNOWN_ERROR',
    CONVERSATION_TOO_LONG = 'CONVERSATION_TOO_LONG',
    MESSAGE_TOO_LONG = 'MESSAGE_TOO_LONG'
}

export enum ActionType {
    SIGN_IN = 'SIGN_IN',
    ADD_FUNDS = 'ADD_FUNDS',
    UPGRADE = 'UPGRADE',
    REDUCE_FILES = 'REDUCE_FILES',
    RETRY = 'RETRY',
    NONE = 'NONE'
}

export const ERROR_DEFINITIONS: Record<ErrorType, {
    message: string;
    action: ActionType;
}> = {
    [ErrorType.INSUFFICIENT_BALANCE]: {
        message: "You don't have enough balance to use this model. Please add funds to your account.",
        action: ActionType.ADD_FUNDS
    },
    [ErrorType.MODEL_ACCESS_RESTRICTED]: {
        message: "You don't have access to this model. Please upgrade your subscription to use premium models.",
        action: ActionType.UPGRADE
    },
    [ErrorType.GUEST_RATE_LIMITED]: {
        message: "Message limit exceeded. Guest users are limited to 10 messages per day, sign up for a free account to get more.",
        action: ActionType.SIGN_IN
    },
    [ErrorType.TOO_MANY_FILES]: {
        message: "Maximum files allowed per request exceeded.",
        action: ActionType.REDUCE_FILES
    },
    [ErrorType.USER_UNAUTHORIZED]: {
        message: "You need to sign in to use this feature.",
        action: ActionType.SIGN_IN
    },
    [ErrorType.AUTHORIZATION_FAILED]: {
        message: "Authorization failed - Refresh the page and try again.",
        action: ActionType.RETRY
    },
    [ErrorType.GENERATION_FAILED]: {
        message: "An error occurred during generation. Please try again later.",
        action: ActionType.RETRY
    },
    [ErrorType.IMAGE_GENERATION_FAILED]: {
        message: "An error occurred during image generation. Please try again later.",
        action: ActionType.RETRY
    },
    [ErrorType.IMAGE_UPLOAD_FAILED]: {
        message: "Failed to save the generated image. Please retry.",
        action: ActionType.RETRY
    },
    [ErrorType.UNKNOWN_ERROR]: {
        message: "An unknown error occurred. Please try again later.",
        action: ActionType.RETRY
    },
    [ErrorType.CONVERSATION_TOO_LONG]: {
        message: "Conversation is too long. Guest users are limited to 10,000 tokens per conversation.",
        action: ActionType.SIGN_IN
    },
    [ErrorType.MESSAGE_TOO_LONG]: {
        message: "Message is too long. Guest users are limited to 1,000 tokens per message.",
        action: ActionType.SIGN_IN
    }
    
} 